import cx from "classnames";
import React from "react";
import "./Chip.scss";

type ChipVariant = "primary" | "secondary" | "tertiary" | "warning" | "error" | "success";

type Props = {
  variant?: ChipVariant;
  trailingIcon?: ({ ...props }: React.SVGProps<SVGSVGElement>) => JSX.Element;
  leadingIcon?: ({ ...props }: React.SVGProps<SVGSVGElement>) => JSX.Element;
  className?: string;
  children?: React.ReactNode;
};

const Chip = ({ variant = "primary", trailingIcon, leadingIcon, children, className }: Props) => {
  return (
    <div className={cx("Chip", `Chip--${variant}`, className)}>
      {leadingIcon && <div className="Chip__icon Chip__icon--leading">{leadingIcon({})}</div>}
      <span className="Chip__text">{children}</span>
      {trailingIcon && <div className="Chip__icon Chip__icon--trailing">{trailingIcon({})}</div>}
    </div>
  );
};

export default Chip;
